<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Device Dashboard</span>
    </div>
    <!-- Redirect Button -->
    @if (Device_dashboardView) {
      <div class="button-group">
        <app-common-component-dropdown-search
          id="selectedDeviceModelId"
          [items]="deviceModelNameList"
          [initialValue]="this.graphForm.get('selectedDeviceModelId')?.value"
          [placeHolder]="'Select Model Name'"
          (itemSelected)="onDeviceModelNameSelectionChange($event)"
        ></app-common-component-dropdown-search>
        <app-common-component-dropdown-search
          id="selectedCustomerId"
          [items]="customerNameList"
          [initialValue]="this.graphForm.get('selectedCustomerId')?.value"
          [placeHolder]="'Select Customer Name'"
          (itemSelected)="onCustomerNameSelectionChange($event)"
        ></app-common-component-dropdown-search>
      </div>
    }
  </div>

  <!-- KPI Section -->
  @if (Device_dashboardView) {
    <div class="kpi-section">
      <!-- Total Production Devices -->
      <div
        class="kpi-card kpi-gradient-blue"
        (click)="fetchDeviceList('Total Production Devices')"
        tabindex="0"
        (keydown.enter)="fetchDeviceList('Total Production Devices')"
      >
        <div class="kpi-details">
          <span class="kpi-content">Total Production Devices</span>
          <span class="kpi-value">
            {{ productionDevice ? productionDevice : 0 }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/production.png"
            alt="Total Production Devices"
          />
        </div>
      </div>

      <!-- Dispatched Devices -->
      <div
        class="kpi-card kpi-gradient-purple"
        (click)="fetchDeviceList('Total Dispatched Devices')"
        tabindex="0"
        (keydown.enter)="fetchDeviceList('Total Dispatched Devices')"
      >
        <div class="kpi-details">
          <span class="kpi-content">Total Dispatched Devices</span>
          <span class="kpi-value">
            {{ dispatchedCount ? dispatchedCount : 0 }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/dispatched.png"
            alt="Total Dispatched Devices"
          />
        </div>
      </div>

      <!-- Installed Devices -->
      <div
        class="kpi-card kpi-gradient-orange"
        (click)="fetchDeviceList('Total Installed Devices')"
        tabindex="0"
        (keydown.enter)="fetchDeviceList('Total Installed Devices')"
      >
        <div class="kpi-details">
          <span class="kpi-content">Total Installed Devices</span>
          <span class="kpi-value">
            {{ installedCount ? installedCount : 0 }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/installed.png"
            alt="Total Installed Devices"
          />
        </div>
      </div>

      <!-- Discarded Devices -->
      <div
        class="kpi-card kpi-gradient-pink"
        (click)="fetchDeviceList('Total Discarded Devices')"
        tabindex="0"
        (keydown.enter)="fetchDeviceList('Total Discarded Devices')"
      >
        <div class="kpi-details">
          <span class="kpi-content">Total Discarded Devices</span>
          <span class="kpi-value">
            {{ discardedCount ? discardedCount : 0 }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/discard.png"
            alt="Total Discarded Devices"
          />
        </div>
      </div>
    </div>

    <!-- Devices Not Active From Graph-->
    <!-- Graph Section -->
    <div class="graph-section">
      <!-- Devices Not Active From Graph-->
      <div
        class="graph-card"
        tabindex="0"
        (keydown.enter)="fetchDeviceList('Device Activity Overview')"
        (click)="fetchDeviceList('Device Activity Overview')"
      >
        <div class="graph-header">
          <h3 class="graph-title">Device Activity Overview</h3>
        </div>
        <div class="graph-body">
          <canvas
            baseChart
            [data]="deviceActivityOverviewBarChartData"
            [options]="barChartOption"
            [type]="'bar'"
          >
          </canvas>
        </div>
      </div>

      <!-- Firmware Wise Device Details Graph-->
      @if (projectName === 'Sampark') {
        <div
          class="graph-card"
          tabindex="0"
          (keydown.enter)="fetchDeviceList('Firmware Wise Devices')"
          (click)="fetchDeviceList('Firmware Wise Devices')"
        >
          <div class="graph-header">
            <h3 class="graph-title">Firmware Wise Devices</h3>
          </div>
          <div class="graph-body">
            <canvas
              baseChart
              [data]="firmwareWiseDeviceBarChartData"
              [options]="barChartOption"
              [type]="'bar'"
            >
            </canvas>
          </div>
        </div>
      } @else {
        <div
          class="graph-card"
          tabindex="0"
          (keydown.enter)="fetchDeviceList('Boot loader Version Wise Devices')"
          (click)="fetchDeviceList('Boot loader Version Wise Devices')"
        >
          <div class="graph-header">
            <h3 class="graph-title">Boot loader Version Wise Devices</h3>
          </div>
          <div class="graph-body">
            <canvas
              baseChart
              [data]="bootLoaderVersionWiseDeviceBarChartData"
              [options]="barChartOption"
              [type]="'bar'"
            >
            </canvas>
          </div>
        </div>

        <div
          class="graph-card"
          tabindex="0"
          (click)="fetchDeviceList('CPU Version Wise Devices')"
        >
          <div class="graph-header">
            <h3 class="graph-title">CPU Version Wise Devices</h3>
          </div>

          <div class="graph-body">
            <canvas
              baseChart
              [data]="cpuWiseDeviceBarChartData"
              [options]="barChartOption"
              [type]="'bar'"
            >
            </canvas>
          </div>
        </div>

        <div
          class="graph-card"
          tabindex="0"
          (keydown.enter)="fetchDeviceList('MCU Version Wise Devices')"
          (click)="fetchDeviceList('MCU Version Wise Devices')"
        >
          <div class="graph-header">
            <h3 class="graph-title">MCU Version Wise Devices</h3>
          </div>

          <div class="graph-body">
            <canvas
              baseChart
              [data]="mcuWiseDeviceBarChartData"
              [options]="barChartOption"
              [type]="'bar'"
            >
            </canvas>
          </div>
        </div>
      }
    </div>
    <div class="component-container" #tableContainer>
      <!-- Component Header Section -->
      <form [formGroup]="graphForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">
            {{ selectedPageTitle }}
          </h6>
          <!-- Total Production Devices -->
          <div class="component-actions">
            @if (selectedPageTitle === 'Total Production Devices') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelProductionDeviceData()"
                value="excel"
              >
                Export
                <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchProducedDevices')?.value
                "
                (searchSubmit)="searchTotalProductionDevice($event)"
              ></app-common-search>
            }
            <!-- Dispatched Devices -->
            @if (selectedPageTitle === 'Total Dispatched Devices') {
              <!-- <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelDispatchedDeviceData()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button> -->
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchDispatchedDevices')?.value
                "
                (searchSubmit)="searchDispatchedDevices($event)"
              ></app-common-search>
            }

            <!-- Installed Devices -->
            @if (selectedPageTitle === 'Total Installed Devices') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelInstalledDevices()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchInstalledDevices')?.value
                "
                (searchSubmit)="searchInstalledDevices($event)"
              ></app-common-search>
            }
            @if (selectedPageTitle === 'Total Discarded Devices') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelDiscardedDevices()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchDiscardedDevices')?.value
                "
                (searchSubmit)="searchDiscardedDevices($event)"
              ></app-common-search>
            }
            <!-- Devices Not Active From Graph-->
            @if (selectedPageTitle === 'Device Activity Overview') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelDeviceNotActiveFromData()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-component-dropdown-search
                [items]="activityOverviewFilter"
                [initialValue]="graphForm?.get('devicesNotActiveSortBy')?.value"
                [placeHolder]="'Select Activity Version'"
                (itemSelected)="onDevicesNotActiveSelectionChange($event)"
              ></app-common-component-dropdown-search>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchDevicesNotActiveFrom')?.value
                "
                (searchSubmit)="searchDevicesNotActiveFrom($event)"
              ></app-common-search>
            }
            <!-- Firmware Wise Details Graph-->
            @if (selectedPageTitle === 'Firmware Wise Devices') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelFirmwareWiseDetails()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-component-dropdown-search
                [items]="firmwareNamesList"
                [initialValue]="graphForm?.get('firmwareWiseSortBy')?.value"
                [placeHolder]="'Select Firmware Version'"
                (itemSelected)="onDevicesFirmwareSelectionChange($event)"
              ></app-common-component-dropdown-search>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchFirmwareWisedetails')?.value
                "
                (searchSubmit)="searchDevicesFirmware($event)"
              ></app-common-search>
            }
            @if (selectedPageTitle === 'Boot loader Version Wise Devices') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelBootVersionWiseDetails()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-component-dropdown-search
                [items]="bootNamesList"
                [initialValue]="graphForm?.get('firmwareWiseSortBy')?.value"
                [placeHolder]="'Select Boot Version'"
                (itemSelected)="onDevicesFirmwareSelectionChange($event)"
              ></app-common-component-dropdown-search>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchBootVersionWiseDetails')?.value
                "
                (searchSubmit)="searchDevicesFirmware($event)"
              ></app-common-search>
            }
            @if (selectedPageTitle === 'MCU Version Wise Devices') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelMcuVersionWiseDetails()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-component-dropdown-search
                [items]="mcuNamesList"
                [initialValue]="graphForm?.get('firmwareWiseSortBy')?.value"
                [placeHolder]="'Select Mcu Version'"
                (itemSelected)="onDevicesFirmwareSelectionChange($event)"
              ></app-common-component-dropdown-search>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchMcuVersionWiseDetails')?.value
                "
                (searchSubmit)="searchDevicesFirmware($event)"
              ></app-common-search>
            }
            @if (selectedPageTitle === 'CPU Version Wise Devices') {
              <button
                class="primary-button"
                data-toggle="modal"
                [disabled]="deviceDetailsList.length === 0"
                (click)="exportToExcelCpuVersionWiseDetails()"
                value="excel"
              >
                Export <mat-icon class="btn-icon">download</mat-icon>
              </button>
              <app-common-component-dropdown-search
                [items]="cpuNamesList"
                [initialValue]="graphForm?.get('firmwareWiseSortBy')?.value"
                [placeHolder]="'Select Cpu Version'"
                (itemSelected)="onDevicesFirmwareSelectionChange($event)"
              ></app-common-component-dropdown-search>
              <app-common-search
                [initialSearchValue]="
                  graphForm?.get('searchCpuVersionWiseDetails')?.value
                "
                (searchSubmit)="searchDevicesFirmware($event)"
              ></app-common-search>
            }
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                @for (
                  header of headerlist[0][selectedPageTitle];
                  track header
                ) {
                  <th>
                    {{ header }}
                  </th>
                }
                <th>Action</th>
              </tr>
            </thead>
            @if (deviceDetailsList.length > 0) {
              <tbody>
                @for (deviceDetails of deviceDetailsList; track deviceDetails) {
                  <tr>
                    @for (
                      configA of headerlistValue[0][selectedPageTitle]
                        | paginate
                          : {
                              id: 'paginate',
                              itemsPerPage: pageSize,
                              currentPage: currentPage,
                              totalItems: totalCount,
                            };
                      track configA
                    ) {
                      <td tabindex="0">
                        {{ deviceDetails[configA] || '--' }}
                      </td>
                    }
                    <td>
                      <div class="action-buttons">
                        <button
                          (click)="view(deviceDetails.uid, deviceDetails.imei)"
                          [disabled]="!Device_dashboardView"
                          class="primary-button view-button"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (deviceDetailsList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          @if (deviceDetailsList.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalCount"
              [pageSize]="pageSize"
              [currentPage]="currentPage"
              [totalPages]="totalPage"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </form>
    </div>
  }
</div>
